/**
 * This is the changeforgottenpassword routes configuration.
 * Only configure routes in this file.
 * @memberOf changeforgottenpassword Module
 * @namespace changeforgottenpassword Routes
 */
import changeforgottenpasswordTemplate from './changeforgottenpassword.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf changeforgottenpassword Module.changeforgottenpassword Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the changeforgottenpassword state and assign the template and controller. */
    $stateProvider
		.state('login.changeforgottenpassword', {
			url: '^/selfservice/login/forgotpassword/change',
			template: changeforgottenpasswordTemplate,
			controller: 'changeforgottenpasswordController',
			controllerAs: 'vm'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/login/changeforgottenpassword/changeforgottenpassword.route.js